import React from 'react';
import Popup from '../Popup';
import './SearchInfoPlaylistPopup.scss';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { formatDateToDisplay } from '../../utils';
import { colorIsDarkSimple } from '../../generalConstant';
import EditIcn from '../../assets/edit_icn.svg';
import { useHistory } from 'react-router-dom';

const SearchInfoPlaylistPopup = ({ open, onClose, playlists }) => {
  const history = useHistory();

  const handleEditClick = (selectedPlayList) => {
    history.push({
      pathname: selectedPlayList.type === 3 ? '/royalties/edit-playlist-secondery' : '/non-royalties/edit-playlist-secondery',
      state: { selectedPlayList },
    });
  };

  return (
    <Popup open={open} onClose={onClose} dialogClassName="SearchInfoPlaylistPopup">
      <div className="import-customer-playlist-content">
        <div className="import-customer-playlist-content-header">
          <h4>Playlists </h4>
        </div>

        <TableContainer className="tbl_wraper" component={Paper}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                <TableCell className="table_font">Result</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Playlist Name</TableCell>
                <TableCell>Tags</TableCell>
                <TableCell className="text_center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(playlists) && playlists.length > 0 ? (
                playlists.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                    <TableCell align="justify" style={{ fontWeight: 'bold' }}>
                      <p style={{ paddingTop: '20px' }}>#{++index}</p>
                      {row.image ? (
                        <img
                          src={`${process.env.REACT_APP_MEDIA_URL}playlist_images/${row.image}?${new Date().getTime()}`}
                          crossorigin="anonymous"
                          alt="not-found"
                          className="imageContainerGet"
                        />
                      ) : (
                        <div className="thumbNail">
                          <p>{row.name?.[0]}</p>
                        </div>
                      )}
                    </TableCell>
                    <TableCell>{formatDateToDisplay(row.createdAt)}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: 'flex',
                          maxWidth: '200px',
                          flexWrap: 'wrap',
                        }}
                      >
                        {row.tags && row.tags.length > 0 ? (
                          row.tags.map((tag) => (
                            <div
                              className="tag_box"
                              key={tag.id}
                              style={{
                                background: tag.color,
                                color: colorIsDarkSimple(tag.color) ? 'white' : 'black',
                                maxWidth: '200px',
                                height: '24px',
                                overflow: 'hidden',
                              }}
                            >
                              {tag.name.length > 25 ? tag.name.slice(0, 25) + '...' : tag.name}
                            </div>
                          ))
                        ) : (
                          <div>-</div>
                        )}
                      </div>
                    </TableCell>
                    <TableCell >
                      <span className="action_icn">
                        <img alt="" src={EditIcn} onClick={() => handleEditClick(row)} />
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                    No playlists found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

      </div>
    </Popup>
  );
};

export default SearchInfoPlaylistPopup;

